import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHeightStuffing = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 100,
	height: 100,
	viewBox: "0 0 100 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_3004_29323",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 100,
			height: 100,
			children: /* @__PURE__ */ _jsx("rect", {
				x: .5,
				y: .5,
				width: 99,
				height: 99,
				fill: "#C4C4C4",
				stroke: "#9EA9B9"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_3004_29323)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M97.3168 73.6341L97.3171 58.7105L55.9967 81.9658L55.9963 96.8894L97.3168 73.6341Z",
					fill: "#FDF1E6",
					stroke: "#A35705",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M55.9979 81.9655L34.1751 70.1513L34.1744 85.1351L55.9973 96.9493L55.9979 81.9655Z",
					fill: "#FDF1E6",
					stroke: "#A35705",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M97.4984 58.5527L75.7989 46.8054L34.3009 70.2184L56.0004 81.9657L97.4984 58.5527Z",
					fill: "#FDF1E6",
					stroke: "#A35705",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M97.3168 59.0486L97.3171 44.1251L55.9967 67.3804L55.9963 82.304L97.3168 59.0486Z",
					fill: "#FDF1E6",
					stroke: "#A35705",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M55.9979 67.3801L34.1751 55.5659L34.1744 70.5497L55.9973 82.3639L55.9979 67.3801Z",
					fill: "#FDF1E6",
					stroke: "#A35705",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M97.4984 43.9672L75.7989 32.2199L34.3009 55.633L56.0004 67.3803L97.4984 43.9672Z",
					fill: "#FDF1E6",
					stroke: "#A35705",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M97.3168 44.4637L97.3171 29.5401L55.9967 52.7954L55.9963 67.719L97.3168 44.4637Z",
					fill: "#FDF1E6",
					stroke: "#A35705",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M55.9979 52.7951L34.1751 40.9809L34.1744 55.9647L55.9973 67.7789L55.9979 52.7951Z",
					fill: "#FDF1E6",
					stroke: "#A35705",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M97.4984 29.3822L75.7989 17.635L34.3009 41.048L56.0004 52.7953L97.4984 29.3822Z",
					fill: "#FDF1E6",
					stroke: "#A35705",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M97.3168 29.8782L97.3171 14.9547L55.9967 38.21L55.9963 53.1336L97.3168 29.8782Z",
					fill: "#F6DCC4",
					stroke: "#A35705",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M55.9979 38.2097L34.1751 26.3955L34.1744 41.3793L55.9973 53.1935L55.9979 38.2097Z",
					fill: "#F6DCC4",
					stroke: "#A35705",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M97.4984 14.7968L75.7989 3.04953L34.3009 26.4626L56.0004 38.2098L97.4984 14.7968Z",
					fill: "#F6DCC4",
					stroke: "#A35705",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .4,
					d: "M28.2332 80.2858C28.2282 81.2078 27.975 82.1008 27.5246 82.7628C27.0742 83.425 26.4767 83.784 25.8744 83.7969L12.4483 83.9447L12.4472 83.945C12.1544 83.9489 11.8696 83.8677 11.608 83.7109C11.3466 83.5541 11.1085 83.3223 10.9077 83.0272C10.7065 82.7316 10.5434 82.3739 10.4322 81.9713C10.3209 81.5684 10.2642 81.1292 10.2689 80.6797L10.2689 80.6748L10.6338 9.39557C10.6389 8.47375 10.8918 7.58131 11.342 6.91946C11.7362 6.34003 12.243 5.9926 12.767 5.90616L12.9923 5.88536L26.428 5.74572C26.7198 5.74508 27.003 5.82914 27.2633 5.98736C27.5239 6.14583 27.7613 6.37817 27.9614 6.67401C28.1619 6.97028 28.3239 7.32815 28.4347 7.73051C28.5456 8.13327 28.6028 8.57205 28.5983 9.02122L28.598 9.02457L28.547 18.4519L18.8445 18.5737L18.8438 18.573C18.5451 18.5751 18.2819 18.7473 18.0978 19.017C17.9136 19.2869 17.8078 19.6534 17.8074 20.046L17.8085 20.0457L17.7953 22.0204C17.794 22.2148 17.8192 22.415 17.8731 22.6091C17.9274 22.8039 18.0099 22.9899 18.1197 23.1512C18.2298 23.3129 18.3625 23.4431 18.509 23.5314C18.6552 23.6197 18.8083 23.6616 18.9566 23.6606L18.9574 23.6613L28.5208 23.559L28.486 30.3445L24.1473 30.3931L24.1465 30.3925C23.848 30.3946 23.5854 30.5675 23.4013 30.837C23.2178 31.106 23.1128 31.4708 23.1116 31.8618L23.1105 31.8621L23.0981 33.8398L23.0992 33.8396C23.0976 34.0342 23.1216 34.235 23.1756 34.4295C23.2297 34.6244 23.3123 34.8101 23.4222 34.9716C23.5324 35.1335 23.6653 35.2641 23.8121 35.3524C23.9587 35.4405 24.1117 35.4822 24.2602 35.4807L24.2613 35.4804L28.465 35.4257L28.4298 42.2097L18.7053 42.3141C18.4069 42.3165 18.1443 42.4883 17.9604 42.7578C17.7762 43.0278 17.6704 43.3942 17.67 43.7868L17.6711 43.7865L17.6579 45.7612L17.659 45.7609C17.6577 45.9555 17.6817 46.1556 17.7358 46.3499C17.79 46.5447 17.8725 46.7308 17.9823 46.892C18.0924 47.0536 18.2251 47.1839 18.3716 47.2722C18.5178 47.3605 18.6709 47.4025 18.8192 47.4014L18.8203 47.4012L28.4036 47.289L28.3662 54.0735L24.0269 54.1337L24.0262 54.1331C23.7275 54.1352 23.4643 54.3074 23.2802 54.577C23.0966 54.846 22.9924 55.2114 22.9913 55.6024L22.9902 55.6027L22.9777 57.5805L22.9788 57.5802C22.9772 57.7747 23.0005 57.9751 23.0544 58.1695C23.1086 58.3646 23.1918 58.5506 23.3018 58.7122C23.4121 58.8742 23.5449 59.0048 23.6917 59.093C23.8383 59.1811 23.9913 59.2229 24.1398 59.2213L24.1409 59.221L28.3417 59.1687L28.3065 65.9551L18.5902 66.064L18.5894 66.0634C18.2908 66.0656 18.0283 66.2383 17.8442 66.508C17.6608 66.7768 17.5561 67.1411 17.5549 67.5318L17.5538 67.5321L17.5417 69.5114L17.5428 69.5111C17.5413 69.7055 17.565 69.9053 17.6188 70.0995C17.6729 70.2946 17.7551 70.4809 17.865 70.6425C17.9753 70.8044 18.1086 70.9342 18.2554 71.0224C18.4019 71.1105 18.5549 71.1523 18.7034 71.1507L28.282 71.0504L28.2332 80.2858Z",
					fill: "#F6DCC4",
					stroke: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M28.7893 22.9862L28.8077 19.0161L18.7523 19.1411C18.5717 19.1424 18.3988 19.2479 18.2713 19.4347C18.1438 19.6215 18.0721 19.8744 18.0719 20.1381L18.0595 22.1162C18.0586 22.2449 18.0752 22.3726 18.1084 22.4919C18.1416 22.6112 18.1907 22.7196 18.2529 22.8109C18.315 22.9022 18.389 22.9745 18.4705 23.0237C18.552 23.0728 18.6393 23.0978 18.7275 23.0972L28.7893 22.9862ZM28.6698 46.7189L28.6896 42.7729L18.6127 42.8798C18.4321 42.8811 18.2592 42.9867 18.1317 43.1735C18.0042 43.3603 17.9326 43.6131 17.9323 43.8769L17.9199 45.8549C17.919 45.9837 17.9356 46.1114 17.9688 46.2306C18.002 46.3499 18.0511 46.4583 18.1133 46.5496C18.1754 46.6409 18.2494 46.7133 18.3309 46.7624C18.4124 46.8116 18.4998 46.8366 18.5879 46.836L28.6698 46.7189ZM28.7299 34.8542L28.749 30.9049L24.0571 30.9566C23.8765 30.9578 23.7036 31.0634 23.5761 31.2502C23.4487 31.437 23.377 31.6899 23.3767 31.9536L23.3644 33.9317C23.3632 34.0605 23.3797 34.1884 23.4128 34.3078C23.4459 34.4272 23.495 34.5358 23.5572 34.6271C23.6194 34.7185 23.6935 34.7908 23.7751 34.8398C23.8566 34.8889 23.9441 34.9136 24.0323 34.9127L28.7299 34.8542ZM18.4727 70.588L28.5503 70.4817L28.5659 66.5164L18.4956 66.6289C18.3151 66.6302 18.1421 66.7358 18.0147 66.9226C17.8872 67.1094 17.8155 67.3622 17.8153 67.626L17.8029 69.604C17.8017 69.7329 17.8182 69.8607 17.8513 69.9801C17.8844 70.0996 17.9335 70.2081 17.9957 70.2995C18.0579 70.3909 18.132 70.4632 18.2136 70.5122C18.2952 70.5612 18.3826 70.586 18.4709 70.5851L18.4727 70.588ZM28.6099 58.6008L28.6254 54.6355L23.9327 54.6994C23.7521 54.7007 23.5792 54.8063 23.4517 54.9931C23.3242 55.1799 23.2525 55.4327 23.2523 55.6965L23.2399 57.6745C23.2388 57.8033 23.2552 57.9312 23.2883 58.0506C23.3214 58.1701 23.3705 58.2786 23.4327 58.37C23.495 58.4614 23.569 58.5337 23.6506 58.5827C23.7322 58.6317 23.8197 58.6565 23.9079 58.6556L28.6099 58.6008Z",
					fill: "#F6DCC4"
				}),
				/* @__PURE__ */ _jsx("g", {
					clipPath: "url(#clip0_3004_29323)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M39.0746 22.2103L33.2414 22.2103L34.5332 23.6232C34.6219 23.7202 34.6717 23.8517 34.6717 23.9889C34.6717 24.126 34.6219 24.2575 34.5332 24.3545L34.1983 24.7208C34.1544 24.769 34.1022 24.8072 34.0448 24.8333C33.9873 24.8594 33.9257 24.8729 33.8635 24.8729C33.8012 24.8729 33.7396 24.8594 33.6822 24.8333C33.6247 24.8072 33.5725 24.769 33.5286 24.7208L30.8601 21.8003C30.7715 21.7033 30.7217 21.5718 30.7217 21.4346C30.7217 21.2975 30.7715 21.166 30.8601 21.069L33.5301 18.1487C33.5741 18.1005 33.6263 18.0622 33.6837 18.0361C33.7412 18.01 33.8028 17.9966 33.865 17.9966C33.9273 17.9966 33.9889 18.01 34.0463 18.0361C34.1038 18.0622 34.156 18.1005 34.1999 18.1487L34.5348 18.515C34.6235 18.6119 34.6733 18.7434 34.6733 18.8806C34.6733 19.0177 34.6235 19.1492 34.5348 19.2462L33.2429 20.659L39.0746 20.659C39.2 20.659 39.3203 20.7135 39.4089 20.8104C39.4976 20.9074 39.5474 21.0389 39.5474 21.1761L39.5474 21.6932C39.5474 21.8303 39.4976 21.9618 39.4089 22.0588C39.3203 22.1558 39.2 22.2103 39.0746 22.2103Z",
						fill: "#F6DCC4"
					})
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_3004_29323",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 8.82516,
				height: 11.0315,
				fill: "white",
				transform: "translate(30.7227 15.9292)"
			})
		}) })
	]
});
export default SvgHeightStuffing;
